import { VSpace } from '../account/account-settings';
import {
  ChannelLabel,
  PasskeyText,
  SubTitle,
  Title,
} from '../account/account-settings.styled';
import { OnboardBtn } from '../profile/profile.styled';
import { Panel } from '../settings.styled';

import {
  Header,
  Icon,
  StyledUl,
  StyledLi,
  StyledAnchor,
  ControlsTitle,
  Row,
  ColDescription,
  SmallPrimaryButton,
  ControlsStack,
} from './privacy.styled';

import { usePrivacySettings } from './privacy.hooks';

export const PrivacySettings = () => {
  const { handleExportData } = usePrivacySettings();

  return (
    <>
      <Panel>
        <Header>
          <Icon src="/privacy-lock.svg" height={19} alt="Lock icon" />
          <Title>Data privacy</Title>
        </Header>

        <VSpace $h={16} />

        <PasskeyText>
          Mailander is built for confidential, high-stakes conversations. Your insight stays yours, and safeguarding it is our first principle.
        </PasskeyText>

        <VSpace $h={16} />

        <ChannelLabel>How we protect your data</ChannelLabel>
        <StyledUl>
          <StyledLi>
            No model training on your content by default.
          </StyledLi>
          <StyledLi>
            Never sold, never shared for profit. We don’t monetize or rent your data—period.
          </StyledLi>
          <StyledLi>
            End-to-end encryption in transit and at rest, zero-trust architecture, and regular third-party audits.
          </StyledLi>
          <StyledLi>
            Delete any message or your entire account at any time; only material flagged for safety or legal compliance is retained.
          </StyledLi>
        </StyledUl>

        <ChannelLabel>How we use your data</ChannelLabel>
        <StyledUl>
          <StyledLi>
            Safety &amp; integrity. Conversations flagged for abuse or security risks may be
            reviewed by a restricted safety team to keep the platform secure for all users.
          </StyledLi>
          <StyledLi>
            Account &amp; billing. We use your email and subscription details solely for
            verification, invoices, and Mailander-led updates (you can opt out of marketing at any
            time).
          </StyledLi>
          <StyledLi>
            Anonymous metrics. We may aggregate and anonymize usage patterns to improve performance
            and reliability—never in a way that can identify you.
          </StyledLi>
          <StyledLi>
            Optional features. Future tools (e.g., cross-device sync, advanced analytics) may
            request broader access. You’ll always have a clear choice to enable or disable them.
          </StyledLi>
        </StyledUl>

        <ChannelLabel>Your controls</ChannelLabel>
        <StyledUl>
          <StyledLi>Erase chats or export them in one tap from Settings → Data.</StyledLi>
          <StyledLi>Download a full data archive whenever you need it.</StyledLi>
          <StyledLi>
            Close your account instantly—your data is purged from active systems within 30 days
            unless legal obligations apply.
          </StyledLi>
        </StyledUl>

        <VSpace $h={8} />

        <PasskeyText>
          For full details, see the complete{' '}
          <StyledAnchor
            href="https://www.mailander.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </StyledAnchor>{' '}
          and{' '}
          <StyledAnchor
            href="https://www.mailander.com/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </StyledAnchor>
          .
        </PasskeyText>
      </Panel>

      <Panel>
        <ControlsTitle>Data controls</ControlsTitle>
        <VSpace $h={16} />

        <ControlsStack>
          <Row>
            <ColDescription>
              <SubTitle style={{ fontSize: '15px' }}>Export data</SubTitle>
              <PasskeyText>
                Download all your messages, account details, and settings in a single archive.
              </PasskeyText>
            </ColDescription>
            <SmallPrimaryButton as={OnboardBtn} onClick={handleExportData}>
              Export data
            </SmallPrimaryButton>
          </Row>
        </ControlsStack>
      </Panel>
    </>
  );
};
